/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_ReturnedInputs */

const tr_geliver_status_returned = /** @type {(inputs: Geliver_Status_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İade edildi`)
};

const en_geliver_status_returned = /** @type {(inputs: Geliver_Status_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Returned`)
};

const de_geliver_status_returned = /** @type {(inputs: Geliver_Status_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retourniert`)
};

const ru_geliver_status_returned = /** @type {(inputs: Geliver_Status_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возвращено`)
};

/**
* | output |
* | --- |
* | "Returned" |
*
* @param {Geliver_Status_ReturnedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_returned = /** @type {((inputs?: Geliver_Status_ReturnedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_ReturnedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_returned(inputs)
	if (locale === "de") return de_geliver_status_returned(inputs)
	if (locale === "ru") return ru_geliver_status_returned(inputs)
	return tr_geliver_status_returned(inputs)
});